import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from 'kea-resource';

import { ViajeZE } from "./viajeze";
import { Guia } from "./guia";

const controller = rpcController("ViajeZEApp");

export const ViajeZEApp = cacheResource({
    /**Obtiene los datos offline para el inicio de un viaje de ZE en la app */
    ObtenerDestinosViajeZEApp: async (idViajeZE: number): Promise<models.ViajeZEAppIniciado> => await controller('ObtenerDestinosViajeZEApp', { idViajeZE }),

    ObtenerDatosViajeZEApp: async (idViajeZE: number, idDireccionDestino: number): Promise<models.DatosViajeZEApp> => await controller('ObtenerDatosViajeZEApp', { idViajeZE, idDireccionDestino }),

    PuedeAgregarEntrega: async (idViajeZE: number, idDireccionDestino: number): Promise<boolean> => await controller('PuedeAgregarEntrega', { idViajeZE, idDireccionDestino }),

    /**Regresa true si puede marcar como incompleta las entregas de este destino */
    PuedeAgregarIncompleta: async (idViajeZE: number, idDireccionDestino: number): Promise<boolean> => await controller('PuedeAgregarIncompleta', { idViajeZE, idDireccionDestino }),

    /**Registra una entrega incompleta */
    RegistrarEntregaIncompleta: async (model: models.EntregaIncompletaViajeZEAppModel): Promise<boolean> => await controller('RegistrarEntregaIncompleta', {}, model),

    ObtenerGuiasDeEntrega: async (IdViajeZE: number, IdDireccionDestino: number, IdEntrega: number | null): Promise<models.GuiaEntregaZESelect[]> => await controller('ObtenerGuiasDeEntrega', {}, { IdViajeZE, IdDireccionDestino, IdEntrega }),

    /**Obtiene las guías que le corresponden a cierta entrega de ZE */
    ObtenerInformacionEntrega: async (IdViajeZE: number, IdDireccionDestino: number, IdEntrega: number | null): Promise<models.InfoEntregaZE> => await controller('ObtenerInformacionEntrega', {}, { IdViajeZE, IdDireccionDestino, IdEntrega }),

    /**Marca un viaje de EAD como iniciado en la app, verifica que no este iniciado ya */
    IniciarViajeZEApp: async (idViajeZE: number): Promise<void> => await controller('IniciarViajeZEApp', { idViajeZE }),

    /**Marca un viaje de EAD como finalizado y actualiza todos los status necesarios  */
    FinalizarViajeZEApp: async (idViajeZE: number): Promise<void> => await controller('FinalizarViajeZEApp', { idViajeZE }),

    /**
     * Sincroniza un modelo de viaje, aplicando los cambios a la base de datos. Se considera que las entregas realizadas y las incompletas son inmutables por lo que 
     * la sincronización solo implica agregar los registros que no existan a la base de datos
     */
    SincronizarModeloViaje: async (idViajeEAD: number, model: models.ModeloViajeApp): Promise<void> => await controller('SincronizarModeloViaje', { idViajeEAD }, model),

    /**
    * Obtiene los datos de trabajo de la app móvil, la unica razón por la cual el dispositivo quisiera obtner los datos del servidor es porque se hayan borrado
    * de forma no intencional del localStorage, por ejemplo que el navegador reclame el espacio del dispositivo.
    */
    ObtenerModeloViaje: async (): Promise<models.ModeloViajeApp> => await controller('ObtenerModeloViaje', {}),

    /**Obtiene el id del viaje ZE del usuario en caso de que lo haya iniciado */
    ObtenerIdViajeZEUsuario: async (): Promise<number | null> => await controller('ObtenerIdViajeZEUsuario', {}),

    /**Cancela el viaje actualmente iniciado en la app  */
    CancelarViajeZEApp: async (idViajeZE: number): Promise<void> => await controller('CancelarViajeZEApp', { idViajeZE }),

    ObtenerEntrega: async (idEntregaZE: number): Promise<models.EntregaZERealizadaDTO> => await controller('ObtenerEntrega', { idEntregaZE }),

    /**Obtiene una entrega de ZE */
    RealizarEntrega: async (entrega: models.EntregaZERealizadaDTO): Promise<models.EntregaZERealizadaDTO> => await controller('RealizarEntrega', {}, entrega),

    CrearGuiasAcuse: async (idViajeZE: number): Promise<number> => await controller('CrearGuiasAcuse', {idViajeZE}), 
}, {
        ObtenerDestinosViajeZEApp: true,
        ObtenerIdViajeZEUsuario: true,
        ObtenerDatosViajeZEApp: true,
        ObtenerGuiasDeEntrega: true
    }, {
        IniciarViajeZEApp: true,
        FinalizarViajeZEApp: true,
        SincronizarModeloViaje: true,
        CancelarViajeZEApp: true,
        RealizarEntrega: true,
        RegistrarEntregaIncompleta: true
    });

addOnInvalidateHandler(ViajeZEApp, () => invalidateResource(ViajeZE));
addOnInvalidateHandler(ViajeZEApp, () => invalidateResource(Guia));


// WEBPACK FOOTER //
// ./app/resources/items/viajezeapp.tsx